<template>
  <div class="article">
    <p class="article-title">{{$t('article3.title')}}</p>
    <img src="../../../assets/article/3-1.jpg" />
    <p class="article-content" style="font-weight:bold;">{{$t('article3.p1')}}</p>
    <p class="article-content">{{$t('article3.p2')}}</p>
    <img src="../../../assets/article/3-2.jpg" />
    <p class="article-content">
      {{$t('article3.p3')}}
      <span style="color:#cf2a2a">{{$t('article3.p333')}}</span>
    </p>
    <p class="article-content">{{$t('article3.p4')}}</p>
    <img :src="articleImg1" />
    <p class="article-content">{{$t('article3.p5')}}</p>
    <p class="article-content">{{$t('article3.p6')}}</p>
    <p class="article-content">
      {{$t('article3.p7')}}
      <span style="color:#cf2a2a">{{$t('article3.p777')}}</span>
    </p>
    <p class="article-content">{{$t('article3.p8')}}</p>
    <p class="article-content">{{$t('article3.p9')}}</p>
  </div>
</template>
<script>
export default {
  computed: {
    articleImg1() {
      return this.$store.state.articleImg1
    }
  }
}
</script>
